import React from 'react';

// @atlaskit
import PageHeader from '@atlaskit/page-header';

const Header = () => (
  <PageHeader
    bottomBar={(
      <p>
        Please select your table column to see the trend line.
      </p>
    )}
  >
    Please adjust the settings to trending.
  </PageHeader>
);

export default Header;
